import React, { useEffect, useState } from 'react'
import { FooterNavigationProps, FooterMenuItems } from './FooterNavigation.types'
import { useOneTrustBundles, usePrivacyOptOutCheck } from '../../../utils/hooks'
import { APIENDPOINT, getCWPEnvironmentForURL, getMicrositeBase } from '../../../utils/common-utils'
import { cacheGet } from '../../../utils'
import { Menu, MenuType } from '../../Navigation/src/data/data.types'

export const FooterNavigation = (props: FooterNavigationProps) => {
  const [menuData, setMenuData] = useState<MenuType>()
  const menuName = props.content?.menuName
  const siteMapName = props.content?.siteMapName
  const showOptOut = usePrivacyOptOutCheck()
  const { oneTrustLabel, oneTrustUrl } = useOneTrustBundles() as {
    oneTrustLabel: string
    oneTrustUrl: string
  }
  const env = getCWPEnvironmentForURL(window.location.href)
  const url = `${APIENDPOINT(env).menuBase}${menuName}`
  useEffect(() => {
    async function fetchMenuData() {
      const data = await cacheGet(url)
      if (data) setMenuData(data as MenuType)
    }
    fetchMenuData()
  }, [])
  if (menuData?.status) {
    let items = menuData?.data?.menuItems as Menu[]

    if (items && showOptOut) {
      items = [...items, { HstMenuItemRepresentation: { name: oneTrustLabel, url: oneTrustUrl } }]
    }
    return (
      <>
        {menuData?.status === 'error' && <div>{menuData?.error || ''}</div>}
        {menuData?.status === 'fetching' && <div className='loading'></div>}
        {menuData?.status === 'fetched' && (
          <FooterNav menuItems={items} siteMapName={siteMapName} />
        )}
      </>
    )
  } else return <div className='loading'></div>
}
const FooterNav = (props: { menuItems: FooterMenuItems; siteMapName?: string }) => {
  const { menuItems, siteMapName } = props

  const env = getCWPEnvironmentForURL(window.location.href)
  const baseURL = APIENDPOINT(env).base

  return (
    <>
      {menuItems?.map(({ HstMenuItemRepresentation }) => {
        return (
          <li className='ms-listItem' key={HstMenuItemRepresentation.name}>
            <a
              className='u-textColorDefault u-padding4 u-linkClean'
              href={
                HstMenuItemRepresentation.name === 'Sitemap' && siteMapName
                  ? `${baseURL}${siteMapName}/sitemap`
                  : HstMenuItemRepresentation.url
              }
              aria-label={HstMenuItemRepresentation.name}>
              {HstMenuItemRepresentation.name}
            </a>
          </li>
        )
      })}
    </>
  )
}
